module.exports = __webpack_public_path__ + "img/i-whatsapp.c9c8f53a.png";